




















































/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import Component from 'vue-class-component';
import PluginComponent from '@/components/plugins/PluginComponent';
import  { EVENTS } from '@/services/EventBus';

@Component({
  props: {
  },
  components: {
  },
})
export default class BookmarkerPlugin extends PluginComponent {
  static ID = 'BookmarkerPlugin';

  showShareModal = false;

  showAddBookmarkModal = false;

  newBookmarkLabel = '';

  shareLink = '';

  mounted() {
  }

  showModalAddBookmark(){
    this.showAddBookmarkModal = true
  }

  addBookmarkInList() {
    const bookmark = {
      label: this.newBookmarkLabel,
      bbox: this.getMapService().getMapBoundsWGS84()
    };
    this.contextService.addBookmark(bookmark)
    this.showAddBookmarkModal = false
  }

  goToBookmark(bookmark: any): void{
    this.getMapService().zoomToBboxWGS84(bookmark.bbox)
  }

  removeBookmark(index: number) {
    this.contextService.removeBookmark(index)   
  }

  shareBookmark(bookmark: any) {
    const bbox = bookmark.bbox;
    if (bbox) {
      const bboxString = `?bbox=${bbox[0]},${bbox[1]},${bbox[2]},${bbox[3]}`;
      const url = window.location.href;
      const [urlWithoutBbox, hashPart] = url.split('#');
      const cleanUrl = urlWithoutBbox.split('?bbox')[0];
      const idcarte = hashPart.split('?bbox')

      this.shareLink = `${cleanUrl}#${idcarte[0]}${bboxString}`;
      this.showShareModal = true;
    }
  }

  copyLink() {
    navigator.clipboard.writeText(this.shareLink).then(() => {
      this.getEventBus().$emit(EVENTS.NOTIFICATION, 'Lien copié dans le presse-papiers');
    });
  }
}
